export const icons = [
    { name: 'chart-empty', width: 24, height: 24 },
    { name: 'chart-line-new', width: 24, height: 24 },
    { name: 'circle-carrier', width: 24, height: 24 },
    { name: 'circle-cog', width: 24, height: 24 },
    { name: 'circle-mobile', width: 24, height: 24 },
    { name: 'circle-shipper', width: 24, height: 24 },
    { name: 'circle-signal', width: 24, height: 24 },
    { name: 'circle-truck', width: 24, height: 24 },
    { name: 'clipboard', width: 24, height: 24 },
    { name: 'container', width: 24, height: 24 },
    { name: 'plane-arrive', width: 24, height: 24 },
    { name: 'plane-depart', width: 24, height: 24 },
    { name: 'check', width: 24, height: 24 },
    { name: 'circular-check', width: 24, height: 24 },
    { name: 'circular-cross', width: 24, height: 24 },
    { name: 'filter', width: 24, height: 24 },
    { name: 'small-alert', width: 16, height: 16 },
    { name: 'small-arrow-back', width: 16, height: 16 },
    { name: 'small-arrow-down', width: 16, height: 16 },
    { name: 'small-arrow-forward', width: 16, height: 16 },
    { name: 'small-arrow-right', width: 16, height: 16 },
    { name: 'small-arrow-switch-vertical', width: 16, height: 16 },
    { name: 'small-arrow-switch', width: 16, height: 16 },
    { name: 'small-arrow-up', width: 16, height: 16 },
    { name: 'small-bell-off', width: 16, height: 16 },
    { name: 'small-bell', width: 16, height: 16 },
    { name: 'small-bin', width: 16, height: 16 },
    { name: 'small-book', width: 16, height: 16 },
    { name: 'small-bookmark', width: 16, height: 16 },
    { name: 'small-bookmarks', width: 16, height: 16 },
    { name: 'small-calendar', width: 16, height: 16 },
    { name: 'small-caret-down', width: 16, height: 16 },
    { name: 'small-caret-left', width: 16, height: 16 },
    { name: 'small-caret-right', width: 16, height: 16 },
    { name: 'small-caret-up', width: 16, height: 16 },
    { name: 'small-check', width: 16, height: 16 },
    { name: 'small-chevron-collapse', width: 16, height: 16 },
    { name: 'small-chevron-down', width: 16, height: 16 },
    { name: 'small-chevron-expand', width: 16, height: 16 },
    { name: 'small-chevron-left', width: 16, height: 16 },
    { name: 'small-chevron-right', width: 16, height: 16 },
    { name: 'small-chevron-up', width: 16, height: 16 },
    { name: 'small-circular-check', width: 16, height: 16 },
    { name: 'small-circular-clock', width: 16, height: 16 },
    { name: 'small-circular-cross', width: 16, height: 16 },
    { name: 'small-clipboard', width: 16, height: 16 },
    { name: 'small-cloud-off', width: 16, height: 16 },
    { name: 'small-cog', width: 16, height: 16 },
    { name: 'small-collapse', width: 16, height: 16 },
    { name: 'small-company', width: 16, height: 16 },
    { name: 'small-container', width: 16, height: 16 },
    { name: 'small-cross', width: 16, height: 16 },
    { name: 'small-dashboard-add', width: 16, height: 16 },
    { name: 'small-dashboard', width: 16, height: 16 },
    { name: 'small-document', width: 16, height: 16 },
    { name: 'small-download', width: 16, height: 16 },
    { name: 'small-drag-x', width: 16, height: 16 },
    { name: 'small-drag-y', width: 16, height: 16 },
    { name: 'small-earth', width: 16, height: 16 },
    { name: 'small-email', width: 16, height: 16 },
    { name: 'small-expand', width: 16, height: 16 },
    { name: 'small-export', width: 16, height: 16 },
    { name: 'small-filter', width: 16, height: 16 },
    { name: 'small-forward', width: 16, height: 16 },
    { name: 'small-gps-signal', width: 16, height: 16 },
    { name: 'small-hammer', width: 16, height: 16 },
    { name: 'small-harbor', width: 16, height: 16 },
    { name: 'small-heart', width: 16, height: 16 },
    { name: 'small-heartbeat', width: 16, height: 16 },
    { name: 'small-help', width: 16, height: 16 },
    { name: 'small-hidden', width: 16, height: 16 },
    { name: 'small-image-thumbnail', width: 16, height: 16 },
    { name: 'small-import', width: 16, height: 16 },
    { name: 'small-info-outline', width: 16, height: 16 },
    { name: 'small-info', width: 16, height: 16 },
    { name: 'small-item-copy-to', width: 16, height: 16 },
    { name: 'small-item-copy', width: 16, height: 16 },
    { name: 'small-item-duplicate', width: 16, height: 16 },
    { name: 'small-item-move', width: 16, height: 16 },
    { name: 'small-key', width: 16, height: 16 },
    { name: 'small-language', width: 16, height: 16 },
    { name: 'small-layers', width: 16, height: 16 },
    { name: 'small-leaf', width: 16, height: 16 },
    { name: 'small-line-graph', width: 16, height: 16 },
    { name: 'small-link', width: 16, height: 16 },
    { name: 'small-list-collapse', width: 16, height: 16 },
    { name: 'small-list', width: 16, height: 16 },
    { name: 'small-lock-unlocked', width: 16, height: 16 },
    { name: 'small-lock', width: 16, height: 16 },
    { name: 'small-logout', width: 16, height: 16 },
    { name: 'small-minus', width: 16, height: 16 },
    { name: 'small-more-hor', width: 16, height: 16 },
    { name: 'small-more', width: 16, height: 16 },
    { name: 'small-note', width: 16, height: 16 },
    { name: 'small-pencil', width: 16, height: 16 },
    { name: 'small-person', width: 16, height: 16 },
    { name: 'small-pin', width: 16, height: 16 },
    { name: 'small-plane-arrive', width: 16, height: 16 },
    { name: 'small-plane-depart', width: 16, height: 16 },
    { name: 'small-plane', width: 16, height: 16 },
    { name: 'small-play', width: 16, height: 16 },
    { name: 'small-plus', width: 16, height: 16 },
    { name: 'small-redirect', width: 16, height: 16 },
    { name: 'small-refresh', width: 16, height: 16 },
    { name: 'small-rocket', width: 16, height: 16 },
    { name: 'small-search', width: 16, height: 16 },
    { name: 'small-share', width: 16, height: 16 },
    { name: 'small-ship', width: 16, height: 16 },
    { name: 'small-show-all', width: 16, height: 16 },
    { name: 'small-signal', width: 16, height: 16 },
    { name: 'small-sort-asc', width: 16, height: 16 },
    { name: 'small-sort-desc', width: 16, height: 16 },
    { name: 'small-star', width: 16, height: 16 },
    { name: 'small-stars', width: 16, height: 16 },
    { name: 'small-train', width: 16, height: 16 },
    { name: 'small-triangular-alert', width: 16, height: 16 },
    { name: 'small-truck', width: 16, height: 16 },
    { name: 'small-user', width: 16, height: 16 },
    { name: 'small-users', width: 16, height: 16 },
    { name: 'small-value-absolute', width: 16, height: 16 },
    { name: 'small-value-percentage', width: 16, height: 16 },
    { name: 'small-view-map', width: 16, height: 16 },
    { name: 'small-view-timeline', width: 16, height: 16 },
    { name: 'small-visible', width: 16, height: 16 },
    { name: 'small-warehouse', width: 16, height: 16 },
    { name: 'sort', width: 24, height: 24 },
    { name: 'xsmall-drag-x', width: 16, height: 16 },
    { name: 'xsmall-drag-y', width: 16, height: 16 },
    { name: 'xsmall-email', width: 16, height: 16 },
    { name: 'xsmall-link', width: 16, height: 16 },
    { name: 'xsmall-triangular-alert', width: 16, height: 16 },
    { name: 'logomark-6f', width: 24, height: 24 },
    { name: 'logomark-tp', width: 24, height: 24 },
    { name: 'logomark-trimble', width: 24, height: 24 },
    { name: 'small-map-moving', width: 16, height: 16 },
    { name: 'small-map-stopped', width: 16, height: 16 },
    { name: 'small-map-unknown', width: 16, height: 16 },
    { name: 'air', width: 24, height: 24 },
    { name: 'autonomous-quotation', width: 24, height: 24 },
    { name: 'calculator', width: 24, height: 24 },
    { name: 'capacity', width: 24, height: 24 },
    { name: 'carriers', width: 24, height: 24 },
    { name: 'cog', width: 24, height: 24 },
    { name: 'cost-insights', width: 24, height: 24 },
    { name: 'dashboard', width: 24, height: 24 },
    { name: 'earth-mesh', width: 24, height: 24 },
    { name: 'fleet', width: 24, height: 24 },
    { name: 'heart', width: 24, height: 24 },
    { name: 'help', width: 24, height: 24 },
    { name: 'lane-insights', width: 24, height: 24 },
    { name: 'logout', width: 24, height: 24 },
    { name: 'market-analytics', width: 24, height: 24 },
    { name: 'market-insights', width: 24, height: 24 },
    { name: 'notification-rules', width: 24, height: 24 },
    { name: 'ocean', width: 24, height: 24 },
    { name: 'place', width: 24, height: 24 },
    { name: 'shipments', width: 24, height: 24 },
    { name: 'spot-contract', width: 24, height: 24 },
    { name: 'subscription', width: 24, height: 24 },
    { name: 'support', width: 24, height: 24 },
    { name: 'users', width: 24, height: 24 },
    { name: 'small-api', width: 16, height: 16 },
    { name: 'small-gps', width: 16, height: 16 },
    { name: 'small-iot', width: 16, height: 16 },
    { name: 'small-mobile', width: 16, height: 16 },
    { name: 'small-platform', width: 16, height: 16 },
    { name: 'dark', width: 24, height: 24 },
    { name: 'light', width: 24, height: 24 },
];
//# sourceMappingURL=icons.js.map